import React from "react";

const VideoCard = ({ video, description, title }) => {
  return (
    <div
      className="video-card card border rounded mx-auto 
    w-full flex flex-col justify-around items-center mt-8 mb-16 shadow-lg"
    >
      <iframe
        className="video-mdx"
        src={video}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
      <div className="ml-4 py-4 px-4">
        <p className="text-sm tracking-wide text-grey-light ">{description}</p>
      </div>
    </div>
  );
};

export default VideoCard;
